import type { MessageResponse } from '../../../api';
import { message_type } from './const';

export const filterParallelSTTContent = (text: string): string => {
  if (!text) return text;

  const regex = /\[\$hideTxt.*?endHideTxt\$\]/gs;
  return text.replace(regex, '').trim();
};

export const filterMessagesWithInterruptions = (
  messages: MessageResponse[],
  showInterruptions: boolean,
  showParallelSTT: boolean = true
): MessageResponse[] => {
  const groupById = new Map<string, MessageResponse>();
  for (const msg of messages) {
    groupById.set(msg?.id as string, msg);
  }

  let filtered = Array.from(groupById.values());

  if (!showInterruptions) {
    const fullVoice = new Set(
      filtered
        .filter(m => m.message_type === message_type.VOICE)
        .map(m => m.timestamp!)
    );

    filtered = filtered.filter(
      m =>
        !(
          m.message_type === message_type.VOICE_INTERRUPTED &&
          fullVoice.has(m.timestamp!)
        )
    );
  }

  if (!showParallelSTT) {
    filtered = filtered.map(msg => ({
      ...msg,
      message_text: filterParallelSTTContent(msg.message_text || ''),
    }));
  }

  return filtered.sort(
    (a, b) =>
      new Date(a.timestamp!).getTime() - new Date(b.timestamp!).getTime()
  );
};
